import { Button } from "@/components/ui/button";
import { Table, TableBody, TableCell, TableHead, TableHeader, TableRow } from "@/components/ui/table";

interface Props {
    rows: Record<string, string>[];
    mapping: Record<string, { mylesField: string; table: "contact" | "company" }>;
    onConfirm: () => void;
    onBack: () => void;
}

export function ImportPreviewStep({ rows, mapping, onConfirm, onBack }: Props) {
    const mappedHeaders = Object.entries(mapping);
    const previewRows = rows.slice(0, 10);

    return (
        <div>
            <h2 className="mb-2 text-lg font-semibold">Preview Import</h2>
            <p className="mb-4 text-sm text-muted-foreground">
                Showing first {previewRows.length} of {rows.length} rows
            </p>
            <div className="overflow-x-auto rounded-md border">
                <Table>
                    <TableHeader>
                        <TableRow>
                            {mappedHeaders.map(([csv, { mylesField, table }]) => (
                                <TableHead key={csv} className="whitespace-nowrap text-xs">
                                    <div>{mylesField}</div>
                                    <div className="font-normal text-muted-foreground">{table}</div>
                                </TableHead>
                            ))}
                        </TableRow>
                    </TableHeader>
                    <TableBody>
                        {previewRows.map((row, i) => (
                            <TableRow key={i}>
                                {mappedHeaders.map(([csv]) => (
                                    <TableCell key={csv} className="max-w-[200px] truncate text-xs">
                                        {row[csv] || <span className="text-muted-foreground">—</span>}
                                    </TableCell>
                                ))}
                            </TableRow>
                        ))}
                    </TableBody>
                </Table>
            </div>
            <div className="mt-6 flex gap-2">
                <Button variant="outline" onClick={onBack}>Back</Button>
                <Button onClick={onConfirm}>Start Import ({rows.length} rows)</Button>
            </div>
        </div>
    );
}
